var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6222 6.4761C1.53091 6.33234 1.48526 6.26046 1.45971 6.1496C1.44051 6.06632 1.44051 5.93498 1.45971 5.85171C1.48526 5.74084 1.53091 5.66896 1.6222 5.5252C2.37661 4.33721 4.62219 1.33398 8.04431 1.33398C11.4664 1.33398 13.712 4.33721 14.4664 5.5252C14.5577 5.66896 14.6034 5.74084 14.6289 5.85171C14.6481 5.93498 14.6481 6.06632 14.6289 6.1496C14.6034 6.26046 14.5577 6.33234 14.4664 6.4761C13.712 7.66409 11.4664 10.6673 8.04431 10.6673C4.62219 10.6673 2.37661 7.66409 1.6222 6.4761Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04431 8.00065C9.15498 8.00065 10.0554 7.10522 10.0554 6.00065C10.0554 4.89608 9.15498 4.00065 8.04431 4.00065C6.93364 4.00065 6.03327 4.89608 6.03327 6.00065C6.03327 7.10522 6.93364 8.00065 8.04431 8.00065Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewLogo);
export default __webpack_public_path__ + "static/media/Preview-logo.35f1efa61417f5d8cffffb4c8a96015e.svg";
export { ForwardRef as ReactComponent };